import { JetView } from 'webix-jet';
import { countries, devConfig, profile } from 'config/config';

/**
 * Class representing the promotional codes table view.
 * @extends JetView
 */
export default class tablePromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        var vthis = this; // Reference to the current instance

        return {
            view: 'datatable', // Main view type
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                {
                    id: 'rating', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: 'Editar', // Tooltip text
                    template: function (obj) {
                        // Custom template for rendering icons based on permissions
                        if (devConfig.getPermAction('promotionalCodesDelete', 'Torefuse') && obj.State == 'A') {
                            return "<span class='webix_icon wxi-close torefuse'></span>";
                        }
                        return '';
                        if (
                            devConfig.getPermAction('promotionalCodesEdit', 'Edit') &&
                            devConfig.getPermAction('promotionalCodesDelete', 'Torefuse') &&
                            obj.State == 'A'
                        ) {
                            return "<span class='webix_icon wxi-close edit'></span><span class='webix_icon wxi-close torefuse'></span>";
                        } else {
                            if (devConfig.getPermAction('promotionalCodesEdit', 'Edit')) {
                                return "<span class='webix_icon wxi-close edit'></span>";
                            }
                            if (devConfig.getPermAction('promotionalCodesDelete', 'Torefuse') && obj.State == 'A') {
                                return "<span class='webix_icon wxi-close torefuse'></span>";
                            }
                            return '';
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Code', header: _('Código'), width: 250, sort: 'int' }, // Code column
                { id: 'Name', header: _('Nombre'), width: 250, sort: 'int' }, // Name column
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date format for the created date column
                },
                {
                    id: 'State',
                    header: _('Estado'),
                    options: [
                        { id: 'A', value: _('Activo') }, // Active state option
                        { id: 'I', value: _('Inactivo') }, // Inactive state option
                    ],
                    width: 150,
                    sort: 'int',
                },
                { id: 'UserId', header: _('Usuario'), width: 250, sort: 'int' }, // User ID column
                {
                    id: 'Partner',
                    header: _('Partner'),
                    width: 250,
                    sort: 'int',
                },
                { id: 'Country', header: _('País'), width: 250, sort: 'int' }, // Country column
                {
                    id: 'Function',
                    header: _('Función'),
                    options: [{ id: '1', value: _('Registro') }], // Function options
                    width: 150,
                    sort: 'int',
                },
            ],
            onClick: {
                edit: function (euv, id) {
                    // Event handler for edit button click
                    $$('EditCode').show(); // Show edit modal
                },
                torefuse: function (euv, id) {
                    // Event handler for refuse button click
                    var vvthis = this; // Reference to the current instance
                    webix.confirm({
                        type: 'confirm-warning',
                        text: _('Advertencia!') + '<br/>' + _('Desea eliminar código promocional?'), // Confirmation message
                        ok: _('Eliminar código'), // OK button text
                        cancel: _('Salir'), // Cancel button text
                        callback: function (action) {
                            // Callback for confirmation action
                            if (action === true) {
                                var item = vvthis.getItem(id); // Get the item to delete
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json',
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'PromotionalCodes/DeleteCode',
                                        '{ "Id":' + item.Id + '}', // JSON payload for deletion
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(_('Error! ')); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var resp = JSON.parse(text); // Parse response
                                                if (resp.HasError) {
                                                    if (resp.CodeError != undefined) {
                                                        webix.message({
                                                            title: '¡Error!',
                                                            type: 'alert-error',
                                                            text: _('ERROR' + resp.CodeError.toString()),
                                                        });
                                                    } else {
                                                        if (
                                                            resp.AlertMessage != undefined &&
                                                            resp.AlertMessage != 'f'
                                                        ) {
                                                            webix.message({
                                                                text: _(resp.AlertMessage),
                                                                type: 'error',
                                                            });
                                                        }
                                                    }
                                                } else {
                                                    item.State = 'I'; // Update item state to inactive
                                                    webix.message(
                                                        _('Código Eliminado'), // Success message
                                                    );
                                                    vthis.$$('datatable').refresh(); // Refresh the datatable
                                                }
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            on: {
                onBeforeLoad: function () {
                    // Event before loading data
                    this.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    ); // Show loading overlay
                },
                onAfterLoad: function () {
                    // Event after loading data
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            ready: function () {
                // Event when the datatable is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // No data message
                            '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        var url = devConfig.geturlApi() + 'es/PromotionalCodes/GetCodes'; // API URL for fetching codes
        var filter = ''; // Filter string for API requests

        // Event listener for promotional codes filter
        this.on(this.app, 'promotionalCodes:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by player ID
            );
        });

        // Popup for editing codes
        var popup = webix.ui({
            view: 'window',
            id: 'EditCode',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Código') }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Make popup modal
            body: {
                view: 'form',
                id: 'editForm', // Form ID
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // ID field
                    { view: 'text', label: _('Código'), name: 'Code' }, // Code field
                    { view: 'text', label: _('Nombre'), name: 'Name' }, // Name field
                    {
                        view: 'text',
                        label: _('Fecha de Creación'),
                        name: 'CreatedLocalDate',
                        readonly: true, // Readonly field for creation date
                    },
                    {
                        view: 'combo',
                        label: _('Estado'),
                        name: 'State',
                        options: [
                            { id: 'A', value: _('Activado') }, // Activated state option
                            { id: 'I', value: _('Inactivado') }, // Deactivated state option
                        ],
                    },
                    { view: 'text', label: _('Usuario'), name: 'User' }, // User field
                    {
                        view: 'combo',
                        label: _('Partner'),
                        name: 'Partner',
                        options: profile.Partners, // Partner options from profile
                    },
                    {
                        view: 'combo',
                        label: _('Función'),
                        name: 'Function',
                        options: [{ id: '1', value: _('Registro') }], // Function options
                        readonly: true, // Readonly field for function
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Close popup
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'PromotionalCodes/UpdateCode',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Code":"' +
                                                values.Code +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '" ,"State":"' +
                                                values.State +
                                                '", "User":"' +
                                                values.User +
                                                '", "Function":"' +
                                                values.Function +
                                                '"}', // JSON payload for updating code
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Código Actualizado'), // Success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Close popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        $$('editForm').bind($$('datatable')); // Bind edit form to datatable

        // Initialize creation date for new codes
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2);

        // Popup for adding new codes
        var popupAdd = webix.ui({
            view: 'window',
            id: 'AddCode',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Código') }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Make popup modal
            body: {
                view: 'form',
                id: 'addform', // Form ID
                elements: [
                    { view: 'text', label: _('Código'), name: 'Code' }, // Code field
                    { view: 'text', label: _('Nombre'), name: 'Name' }, // Name field
                    {
                        view: 'combo',
                        label: _('Usuario'),
                        name: 'User',
                        options: {
                            body: {
                                dataFeed: function (text) {
                                    // Data feed for user selection
                                    var vthis = this;
                                    if (text.length > 2) {
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'es/Select/BetshopsAndAgentSelect',
                                                '{"Filter":"' + text + '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! '); // Error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text); // Parse response
                                                        if (!resp.HasError) {
                                                            vthis.parse(
                                                                resp.Data, // Populate options
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    }
                                },
                            },
                        },
                    },
                    {
                        view: 'combo',
                        label: _('Partner'),
                        name: 'Partner',
                        options: profile.Partners, // Partner options from profile
                        on: {
                            onChange: function (data, obj) {
                                // Event when partner changes
                                var currentValue = this.getValue(); // Get selected partner
                                const partners = profile.Partners; // Get partners from profile
                                function filter_partners(partners) {
                                    return partners.id == currentValue; // Filter partners by ID
                                }
                                var partner = partners.filter(filter_partners); // Get selected partner
                                $$('selectCountry').define(
                                    'options',
                                    partner[0].Countries.filter(
                                        (item) => item.value != 'Todos' && item.value != 'Default', // Filter countries
                                    ),
                                );
                                $$('selectCountry').refresh(); // Refresh country options
                            },
                        },
                    },
                    {
                        view: 'combo',
                        id: 'selectCountry',
                        label: _('País'),
                        name: 'Country',
                        options: [], // Initialize empty country options
                    },
                    {
                        view: 'combo',
                        label: _('Función'),
                        name: 'Function',
                        options: [{ id: '1', value: _('Registro') }], // Function options
                    },
                    {
                        view: 'combo',
                        label: _('Estado'),
                        name: 'State',
                        options: [
                            { id: 'A', value: _('Activado') }, // Activated state option
                            { id: 'I', value: _('Inactivado') }, // Deactivated state option
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Close popup
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'PromotionalCodes/SaveCode',
                                            '{"Code":"' +
                                                values.Code +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "User":"' +
                                                values.User +
                                                '", "Partner":"' +
                                                values.Partner +
                                                '", "Country":"' +
                                                values.Country +
                                                '", "Function":"' +
                                                values.Function +
                                                '", "State":"' +
                                                values.State +
                                                '"}', // JSON payload for saving new code
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text); // Parse response
                                                    if (json.HasError) {
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: json.AlertMessage, // Show error message
                                                        });
                                                    } else {
                                                        webix.message(
                                                            _('Código Agregado'), // Success message
                                                        );
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    }
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Close popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event listener for adding new codes
        this.on(this.app, 'addCode:button', (filter) => {
            popupAdd.show(); // Show add code popup
        });
    }
}

// FILE DOCUMENTED
